import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DialogBox from '@/components/DialogBox';
import { useToastContext } from '@/contexts/toastContext';
import useApiSubmit from '@/hooks/useApiSubmit';
import candidatesServices, { DeleteCandidateParams } from '@/services/candidates';
import { Paths } from '@/types/routes';
import CandidateResumeComponent, { CandidateResumeType } from './CandidateResume.component';

type CandidateResumeProps = {
  candidate?: CandidateResumeType;
  isNotesPage?: boolean;
  refetchCandidate: () => void;
};

const CandidateResume = ({
  refetchCandidate,
  candidate,
  isNotesPage,
}: CandidateResumeProps): JSX.Element => {
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const toast = useToastContext();
  const deleteCandidateMutation = useApiSubmit<any, DeleteCandidateParams>(
    candidatesServices.deleteCandidate
  );

  const handleClickOnDelete = (): void => {
    setOpenDialog(true);
  };

  const onDeleteCandidate = async (): Promise<void> => {
    if (!candidate) return;

    try {
      await deleteCandidateMutation.mutateAsync({ id: candidate.id });
      setOpenDialog(false);
      navigate(Paths.CANDIDATES);
      toast.showSuccessFeedback('The candidate has been deleted.');
    } catch (err) {
      toast.showErrorFeedback('There was a problem deleting the candidate.');
    }
  };

  return (
    <>
      <CandidateResumeComponent
        refetchCandidate={refetchCandidate}
        openDeleteDialog={handleClickOnDelete}
        isNotesPage={isNotesPage}
        candidate={candidate}
      />
      <DialogBox
        data-testid="delete-candidate-dialog"
        isOpen={openDialog}
        onCancelHandler={() => setOpenDialog(false)}
        onConfirmHandler={() => onDeleteCandidate()}
      />
    </>
  );
};

export default CandidateResume;
